import React from 'react';
import styled from 'styled-components';
import ResponsiveImage from './ResponsiveImage';
import Button from './Button';

const Header = styled.div`
    background-color: #0576ff;
    display: flex;
    flex: 1;
    height: 10vh;
    padding: 0 10px;
    align-items: center;
`;

const Main = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 90vh;
    flex-direction: column;
    background-color: #f9f9f9;
`;

const Title = styled.h2`
    font-family: Roboto-Regular, sans-serif;
    font-weight: bold;
    color: black;
    padding: 0 3px;
`;

const H2 = styled.h3`
    font-family: Roboto-Regular, sans-serif;
    color: gray;
    padding: 0 3px;
`;

const StatusLink = styled.a`
    margin-top: 20px;
    padding: 15px;
    background-color: #0576ff;
    width: 270px;
    text-align: center;
    color: white;
    text-decoration: none;
    font-family: 'Roboto-Regular, sans-serif';
    border-radius: 5px;
`;

const Forbidden = ({ ...props }) => (
    <React.Fragment>
        <Header>
            <ResponsiveImage src={require('../img/icons/logo.png')} alt="Logo do Chat" width="50%" />
        </Header>
        <Main>
            <ResponsiveImage src={require('../img/icons/people-white.png')} alt="Logo do Chat" />
            <Title>Você não possui acesso.</Title>
            <H2>Consulte se o recurso está ativo no sistema!</H2>
            <StatusLink href="https://apps.superlogica.net/imobiliaria/owli">Consulte o seu status</StatusLink>
        </Main>
    </React.Fragment>
);

export default Forbidden;


// WEBPACK FOOTER //
// ./src/components/Forbidden.js